import { Component, EventEmitter, Inject, Input, OnChanges, OnInit, Output, SimpleChanges } from "@angular/core";
import { IWindowService } from "angular";
import type { BaremetricsCalendar, BareMetricsCalendarPreset } from "src/app/reusables/baremetrics-calendar/baremetrics-calendar.component";
import { ModuleManagerDateRangeInfo } from "src/shared/models/module-manager/module-manager-settings.models";
import type SlideoutSettingsManager from "src/shared/models/slideout-settings-manager";
import { DateRangeSelectorService } from "./date-range-selector.service";
import { MomentInput } from 'moment';

@Component({
    selector: 'cv-date-range-selector',
    templateUrl: './date-range-selector.component.html',
    styleUrls: ['./date-range-selector.component.scss']
})
export class DateRangeSelectorComponent implements OnInit, OnChanges {
    @Input() pageName: string;
    @Input() earliestDate: MomentInput;
    @Input() availableDateRanges: ModuleManagerDateRangeInfo[];

    _selectedDateRange: ModuleManagerDateRangeInfo;
    get selectedDateRange() {
        return this._selectedDateRange;
    }
    @Input()
    set selectedDateRange(val: ModuleManagerDateRangeInfo) {
        if (this._selectedDateRange === val)
            return;

        if (val.name.includes(' - ')) {
            this.selectedStartDate = val.startDate;
            this.selectedEndDate = val.endDate;
        } else {
            this.selectedPreset = val.name;
        }

        this._selectedDateRange = val;
        this.selectedDateRangeChange.emit(val);
    }

    @Output() selectedDateRangeChange = new EventEmitter<ModuleManagerDateRangeInfo>();

    @Input() settingsManager?: SlideoutSettingsManager;

    CVAngularDateFormat: string;
    _saveDebounce: number = null;

    selectedStartDate: Date;
    selectedEndDate: Date;
    selectedPreset: string;

    dateRangePresets: BareMetricsCalendarPreset[];
    dropdownOnly: boolean = false;

    constructor(
        @Inject('$window') private $window: IWindowService,
        private service: DateRangeSelectorService,
    ) {
        this.CVAngularDateFormat = $window.CVAngularDateFormat;
    }

    ngOnInit(){
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes.availableDateRanges?.currentValue) {
            this.dateRangePresets = this.availableDateRanges
                .filter(dr => dr.name != "Custom...")
                .map(dr => dr.toBareMetricsPreset());

            this.dropdownOnly = !this.availableDateRanges.map(dr => dr.name).includes('Custom...');
        }
    }

    onDateRangeChanged(calendar: BaremetricsCalendar) {
        let selectedDateRange: ModuleManagerDateRangeInfo;
        if (calendar.selected_preset == null) {
            let customDateRangeBase = this.availableDateRanges.find(dr => dr.name == 'Custom...'); // to get the localized displayName
            selectedDateRange = new ModuleManagerDateRangeInfo();
            selectedDateRange.name = `${calendar.start_date.format(window['CVMomentDateFormat'])} - ${calendar.end_date.format(window['CVMomentDateFormat'])}`;
            selectedDateRange.displayName = customDateRangeBase.displayName;
        } else {
            selectedDateRange = this.availableDateRanges.find(dr => dr.name == calendar.selected_preset);
        }

        if (JSON.stringify(selectedDateRange) === JSON.stringify(this._selectedDateRange))
            return;

        this._selectedDateRange = selectedDateRange;
        this.selectedDateRangeChange.emit(this._selectedDateRange);

        if (this._saveDebounce != null)
            clearTimeout(this._saveDebounce);
        
        this._saveDebounce = this.$window.setTimeout(async () => {
            this._saveDebounce = null;
            await this.service.saveDateRange(this.pageName, this.selectedDateRange?.name);
            this.settingsManager?.onSelectedDateRangeChanged.next(this.selectedDateRange);
        }, 500);
    }
}

